import { createAction, createReducer, on, props } from '@ngrx/store';

export interface IApplicationSettingsState {
    host?: string;
    port?: number;
}

export const DEFAULT_STATE_APPLICATION_SETTINGS: IApplicationSettingsState = {};

// Actions
export const APPLICATION_SETTINGS_SET_ACTION_NAME = '[Application Settings] Set';
export const APPLICATION_SETTINGS_CLEAR_ACTION_NAME = '[Application Settings] Clear';

export const setApplicationSettings = createAction(APPLICATION_SETTINGS_SET_ACTION_NAME, props<IApplicationSettingsState>());
export const clearApplicationSettings = createAction(APPLICATION_SETTINGS_CLEAR_ACTION_NAME);

// Reducers
export const applicationSettingsReducer = createReducer<IApplicationSettingsState>(
    DEFAULT_STATE_APPLICATION_SETTINGS,
    on(setApplicationSettings, (state, currentUser) => currentUser),
    on(clearApplicationSettings, () => DEFAULT_STATE_APPLICATION_SETTINGS),
);
